import serverStatus from '../components/server_status';

export default {
  init() {
    // JavaScript to be fired on all pages
    serverStatus();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/clientareahome.js